import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';

@Component({
  selector: 'app-vitrina-slider-home',
  templateUrl: './vitrina-slider-home.component.html',
  styleUrls: ['./vitrina-slider-home.component.scss'],
})
export class VitrinaSliderHomeComponent implements OnInit {
  @ViewChild('mySlider') slides: IonSlides;
  mySlideOptions = {
    //autoplay: true,
    autoplay: {
      delay: 5000,
    },
    initialSlide: 0,
    slideShadows: true,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    speed: 1100,
    pager: true,
    paginationType: 'fraction',
    effect: 'slide',
    dir: 'rtl',
    //delay: 10000,
    slideinterval: 10000,
  };

  numero_slides: string;
  rutaIMG: string;
  XS: string;
  heightVitrina: string;
  heightImgVitrina: string;
  widthImgVitrina: string;
  maxWidthImg: string;

  sliderHomeList: any = [];
  constructor() { }

  ngOnInit() {
    this.inicializarVariables();
    this.getListaHomeSlider();
    // this.slides.startAutoplay();
  }
  inicializarVariables() {
    this.numero_slides = '5';
    this.rutaIMG = 'assets/img/home/slider/';
    this.XS = 'xs-';
    this.heightVitrina = '480px';
    this.heightImgVitrina = '100%';
    this.widthImgVitrina = '100%';
    this.maxWidthImg = '1190px';

  }

  slidePrev() {
    this.slides.slidePrev();
    this.slides.startAutoplay();
  }
  slideNext() {
    this.slides.slideNext();
    this.slides.startAutoplay();
  }
  getListaHomeSlider() {

    const item_sliderHomeList = [
      // // vitrinaSlide 1: Multiplica x3
      // {
      //   contenidoPrimerTexto_vitrina: '\n\n\n\n',
      //   mobile_PrimerTexto_vitrina: '\n\n\n\n\n\n\n\n\n\n\n\n',
      //   contenidoSegundoTexto_vitrina: '\n\n',
      //   mobile_SegundoTexto_vitrina: '<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>',
      //   hrefBTN1_vitrina: 'https://simple.ripley.com.pe/minisitios/registro-promociones-ripley-peru',
      //   //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
      //   href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
      //   verCondiciones_Mobile:'n',//s/n
      //   contenidoBTN1_vitrina: 'Inscríbete aquí',
      //   textAlignBTN1_Desktop: 'center',   //left,center,right
      //   textAlignBTN1_Mobile: 'left',   //left,center,right
      //   textMarginTopBTN1_Desktop: '0px',   //0px
      //   textMarginTopBTN1_Mobile: '0px',   //0px
      //   textMarginLeftBTN1_Desktop: '350px',   //0px
      //   textMarginLeftBTN1_Mobile: '0px',   //0px
      //   hrefBTN2_vitrina: '',
      //   contenidoBTN2_vitrina: '',
      //   imagen_vitrina: 'banner-home-multiplicax3-may.png',
      //   taggeo: 'banner-home-multiplicax3-may'
      // },
      // vitrinaSlide 1: Multiplica x5
      {
        contenidoPrimerTexto_vitrina: 'En julio, ¡x5 tus Puntos GO!',
        mobile_PrimerTexto_vitrina: 'En julio, ¡x5 tus Puntos GO!',
        contenidoSegundoTexto_vitrina: '<br>Compra en comercios seleccionados* con tu Tarjeta de Crédito Banco Ripley<br><br><br>',
        mobile_SegundoTexto_vitrina: '<br>Compra en comercios seleccionados* con tu Tarjeta de Crédito Banco Ripley<br><br><br>',
        hrefBTN1_vitrina: 'https://bancoripley.com.pe/formularios/index.html?plantilla=campana-1',
        //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
        href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
        verCondiciones_Mobile:'n',//s/n
        contenidoBTN1_vitrina: 'Inscríbete aquí',
        textAlignBTN1_Desktop: 'left',   //left,center,right
        textAlignBTN1_Mobile: 'left',   //left,center,right
        textMarginTopBTN1_Desktop: '0px',   //0px
        textMarginTopBTN1_Mobile: '0px',   //0px
        textMarginLeftBTN1_Desktop: '0px',   //0px
        textMarginLeftBTN1_Mobile: '0px',   //0px
        hrefBTN2_vitrina: '',
        contenidoBTN2_vitrina: '',
        imagen_vitrina: 'banner-home-multiplica5-jul.png',
        taggeo: 'banner-home-multiplica5-jul'
      },
      // // vitrinaSlide 3: Experiencias
      // {
      //   contenidoPrimerTexto_vitrina: '¡Canjea momentos para papá!',
      //   mobile_PrimerTexto_vitrina: '¡Canjea momentos para papá!',
      //   contenidoSegundoTexto_vitrina: '<br>Canjea desde 2,000 Puntos Go vales de S/50 para La Mora, Tanta, Montalvo for Men y muchos más.<br><br>',
      //   mobile_SegundoTexto_vitrina: '<br>Canjea desde 2,000 Puntos Go vales de S/50 para La Mora, Tanta, Montalvo for Men y muchos más.<br><br><br>',
      //   hrefBTN1_vitrina: 'https://bancaenlinea.bancoripley.com.pe/home/ripley-points',
      //   //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
      //   href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
      //   verCondiciones_Mobile:'n',//s/n
      //   contenidoBTN1_vitrina: 'Canjear ahora',
      //   textAlignBTN1_Desktop: 'left',   //left,center,right
      //   textAlignBTN1_Mobile: 'left',   //left,center,right
      //   textMarginTopBTN1_Desktop: '0px',   //0px
      //   textMarginTopBTN1_Mobile: '0px',   //0px
      //   textMarginLeftBTN1_Desktop: '0px',   //0px
      //   textMarginLeftBTN1_Mobile: '0px',   //0px
      //   hrefBTN2_vitrina: '',
      //   contenidoBTN2_vitrina: '',
      //   imagen_vitrina: 'banner-home-expDDP-jun.png',
      //   taggeo: 'banner-home-expDDP-jun'
      // },
      // vitrinaSlide 3: Super Canjes
      {
        contenidoPrimerTexto_vitrina: 'Nuevo mes, nuevos canjes',
        mobile_PrimerTexto_vitrina: 'Nuevo mes, nuevos canjes',
        contenidoSegundoTexto_vitrina: '<br>Revisa el catálogo y usa tus Puntos Go en Tienda Ripley.<br><br>',
        mobile_SegundoTexto_vitrina: '<br>Revisa el catálogo y usa tus Puntos Go en Tienda Ripley.<br><br><br>',
        hrefBTN1_vitrina: 'https://firebasestorage.googleapis.com/v0/b/hbk-prd.appspot.com/o/RPGO%2FCATALOGOS%2FpdfCatalogoSC?alt=media',
        //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
        href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
        verCondiciones_Mobile:'n',//s/n
        contenidoBTN1_vitrina: 'Ver catálogo',
        textAlignBTN1_Desktop: 'left',   //left,center,right
        textAlignBTN1_Mobile: 'left',   //left,center,right
        textMarginTopBTN1_Desktop: '0px',   //0px
        textMarginTopBTN1_Mobile: '0px',   //0px
        textMarginLeftBTN1_Desktop: '0px',   //0px
        textMarginLeftBTN1_Mobile: '0px',   //0px
        hrefBTN2_vitrina: '',
        contenidoBTN2_vitrina: '',
        imagen_vitrina: 'banner-home-supercanje-jul2.png',
        taggeo: 'banner-home-supercanje-jul2'
      },
      
      // // vitrinaSlide 5: Gift Cards
      // {
      //   contenidoPrimerTexto_vitrina: '¡Solo en Junio, vuelve tu Gift Card favorita!',
      //   mobile_PrimerTexto_vitrina: '¡Solo en Junio, vuelve tu Gift Card favorita!',
      //   contenidoSegundoTexto_vitrina: '<br>Canjea una Gift Card de S/50 por solo 2,500 Puntos Go y úsala en Tiendas físicas Ripley, Ripley.com y Ripley App.<br><br>',
      //   mobile_SegundoTexto_vitrina: '<br>Canjea una Gift Card de S/50 por solo 2,500 Puntos Go y úsala en Tiendas físicas Ripley, Ripley.com y Ripley App.<br><br><br>',
      //   hrefBTN1_vitrina: 'https://bancaenlinea.bancoripley.com.pe/home/ripley-points',
      //   //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
      //   href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
      //   verCondiciones_Mobile:'n',//s/n
      //   contenidoBTN1_vitrina: 'Lo quiero ya',
      //   textAlignBTN1_Desktop: 'left',   //left,center,right
      //   textAlignBTN1_Mobile: 'left',   //left,center,right
      //   textMarginTopBTN1_Desktop: '0px',   //0px
      //   textMarginTopBTN1_Mobile: '0px',   //0px
      //   textMarginLeftBTN1_Desktop: '0px',   //0px
      //   textMarginLeftBTN1_Mobile: '0px',   //0px
      //   hrefBTN2_vitrina: '',
      //   contenidoBTN2_vitrina: '',
      //   imagen_vitrina: 'banner-home-giftcar-jun.png',
      //   taggeo: 'banner-home-giftcar-jun'
      // },
      
      // // vitrinaSlide 5: Experiencias 500 Puntos Go
      // {
      //   contenidoPrimerTexto_vitrina: '¡Es momento de canjear!',
      //   mobile_PrimerTexto_vitrina: '¡Es momento de canjear!',
      //   contenidoSegundoTexto_vitrina: '<br>Encuentra experiencias desde 500 Puntos Go, en Bembos, Chinawok, Burger King, Pizza Hut y más.<br><br>',
      //   mobile_SegundoTexto_vitrina: '<br>Encuentra experiencias desde 500 Puntos Go, en Bembos, Chinawok, Burger King, Pizza Hut y más.<br><br><br>',
      //   hrefBTN1_vitrina: 'canjes?category=experiencias',
      //   //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
      //   href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
      //   verCondiciones_Mobile:'n',//s/n
      //   contenidoBTN1_vitrina: 'Mira el catálogo',
      //   textAlignBTN1_Desktop: 'left',   //left,center,right
      //   textAlignBTN1_Mobile: 'left',   //left,center,right
      //   textMarginTopBTN1_Desktop: '0px',   //0px
      //   textMarginTopBTN1_Mobile: '0px',   //0px
      //   textMarginLeftBTN1_Desktop: '0px',   //0px
      //   textMarginLeftBTN1_Mobile: '0px',   //0px
      //   hrefBTN2_vitrina: '',
      //   contenidoBTN2_vitrina: '',
      //   imagen_vitrina: 'banner-home-exp500puntos-jun.png',
      //   taggeo: 'banner-home-exp500puntos-jun'
      // },
      
      // vitrinaSlide 6: Pre Cyber - Latam (Fecha  08 al 11 de julio)
      {
        contenidoPrimerTexto_vitrina: '¡Llegó el Pre-Cyber!',
        mobile_PrimerTexto_vitrina: '¡Llegó el Pre-Cyber!',
        contenidoSegundoTexto_vitrina: '<br>Canjea por millas LATAM Pass con 40% dscto.<br><br><br>',
        mobile_SegundoTexto_vitrina: '<br>Canjea por millas LATAM Pass con 40% dscto.<br><br><br>',
        hrefBTN1_vitrina: 'canje-latam-pass', 
        //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
        href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
        verCondiciones_Mobile:'n',//s/n
        contenidoBTN1_vitrina: 'Canjear ahora',
        textAlignBTN1_Desktop: 'left',   //left,center,right
        textAlignBTN1_Mobile: 'left',   //left,center,right
        textMarginTopBTN1_Desktop: '0px',   //0px
        textMarginTopBTN1_Mobile: '0px',   //0px
        textMarginLeftBTN1_Desktop: '0px',   //0px
        textMarginLeftBTN1_Mobile: '0px',   //0px
        hrefBTN2_vitrina: '',
        contenidoBTN2_vitrina: '',
        imagen_vitrina: 'banner-home-latamregular-jul-8-11.png',
        taggeo: 'banner-home-latamregular-jul-8-11'
      },

      // // vitrinaSlide 6: LATAM regular : Latam (activo desde del 1 al 7 y del 12 al 31 de julio.)
      // {
      //   contenidoPrimerTexto_vitrina: '¡Tu viaje empieza aquí!',
      //   mobile_PrimerTexto_vitrina: '¡Tu viaje empieza aquí!',
      //   contenidoSegundoTexto_vitrina: '<br>Viaja desde 1,500 Puntos Go<br><br><br>',
      //   mobile_SegundoTexto_vitrina: '<br>Viaja desde 1,500 Puntos Go<br><br><br>',
      //   hrefBTN1_vitrina: 'canje-latam-pass', 
      //   //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
      //   href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
      //   verCondiciones_Mobile:'n',//s/n
      //   contenidoBTN1_vitrina: 'Canjea ahora',
      //   textAlignBTN1_Desktop: 'left',   //left,center,right
      //   textAlignBTN1_Mobile: 'left',   //left,center,right
      //   textMarginTopBTN1_Desktop: '0px',   //0px
      //   textMarginTopBTN1_Mobile: '0px',   //0px
      //   textMarginLeftBTN1_Desktop: '0px',   //0px
      //   textMarginLeftBTN1_Mobile: '0px',   //0px
      //   hrefBTN2_vitrina: '',
      //   contenidoBTN2_vitrina: '',
      //   imagen_vitrina: 'banner-home-latamregular-jul.png',
      //   taggeo: 'banner-home-latamregular-jul'
      // },
      
      // vitrinaSlide 6: Primer canje
      {
        contenidoPrimerTexto_vitrina: '¡Tu primer canje empieza aquí!',
        mobile_PrimerTexto_vitrina: '¡Tu primer canje empieza aquí!',
        contenidoSegundoTexto_vitrina: '<br>Empieza con 500 Puntos Go<br><br>',
        mobile_SegundoTexto_vitrina: '<br>Empieza con 500 Puntos Go<br><br><br>',
        hrefBTN1_vitrina: 'https://bancaenlinea.bancoripley.com.pe/home/ripley-points',
        //hrefBTN1_vitrina: 'canjes?category=supercanjes&banner=s',  //ver condiciones desktop
        href_VerCondiciones_Mobile: 'appModalCondicionesExperiencias',
        verCondiciones_Mobile:'n',//s/n
        contenidoBTN1_vitrina: 'Canjea hoy',
        textAlignBTN1_Desktop: 'left',   //left,center,right
        textAlignBTN1_Mobile: 'left',   //left,center,right
        textMarginTopBTN1_Desktop: '0px',   //0px
        textMarginTopBTN1_Mobile: '0px',   //0px
        textMarginLeftBTN1_Desktop: '0px',   //0px
        textMarginLeftBTN1_Mobile: '0px',   //0px
        hrefBTN2_vitrina: '',
        contenidoBTN2_vitrina: '',
        imagen_vitrina: 'banner-home-primercanje-jul.png',
        taggeo: 'banner-home-primercanje-jul'
      },
      
    ];

    this.sliderHomeList = item_sliderHomeList;

  }
}
